<form [formGroup]="myForm">
    <mat-form-field appearance="outline" class="evida-search">
        <mat-icon svgIcon="evida_mit_evida_search" matPrefix>search</mat-icon>
        <input
            type="text"
            [placeholder]="'search.search_faq' | translate"
            [attr.aria-label]="'search.search_faq' | translate"
            matInput
            [formControl]="searchControl"
            [matAutocomplete]="auto"
            aria-autocomplete="list"
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            @for (option of filteredOptions | async; track option) {
                <mat-option [value]="option">
                    {{ option }}
                </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
</form>
